import { bucketBankCertifications } from '../../constants';
import { updateUserService } from '../../services/user';
import { uploadImage } from '../../config/awsConfig';
import { identityErrorMessage } from '../../utils/documents';

const updateAccountBankService = async (accountBankToUpdate, support, fileName, userId) => {
  try {
    const savedImage = await uploadImage(support, fileName, bucketBankCertifications, 'bankCertifications');
    const accountBank = { ...accountBankToUpdate.accountBank, certificate: savedImage };
    return await updateUserService(userId, { accountBank, code: accountBankToUpdate.code });
  } catch (error) {
    return {
      error: true,
      message: identityErrorMessage(error) || error?.publicMessage,
    };
  }
};

export default updateAccountBankService;
